import React, { useEffect, useState } from "react";
// import { toast } from "react-hot-toast";
import { Link, NavLink, useNavigate } from "react-router-dom";
import logo from "../Images/noImage.jpg";
import toast from "react-hot-toast";
import HomeService from "../Services/HomeService";
import profileP from "../Images/profile-pic.png";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAllRemarks,
  fetchRemarksOnProperty,
  toggleSidebar,
  closeSidebar,
} from "../Stores/Slices/SidebarSlices";
import "./style.css";

function Sidebar({ HideSidebar }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userRole = localStorage.getItem("role");
  const userCity = localStorage.getItem("city");
  const loggedUserID = localStorage.getItem("uid");
  const [profileData, setProfileData] = useState("");
  const [toggle, setoggle] = useState(false);
  const [toggleExpenses, setToggleExpenses] = useState(false);
  // const handleClick = () => {
  //   if (document.querySelector("#DarkSwitch").checked) {
  //     document.body.classList.add("drakmode");
  //   } else {
  //     document.body.classList.remove("drakmode");
  //   }
  // };
  const roles = [
    "sales",
    "survey",
    "telecalling",
    "data entry",
    "branch manager",
    "freelancer",
  ];

  const fetchAdminLoginData = async () => {
    const res = await HomeService.getLoginProfile();
    // console.log("this is login profile data", res);

    if (res && res?.status) {
      console.log("GTR23", res);

      setProfileData(res?.data);
    }
  };
  const handlClick = () => {
    dispatch(closeSidebar());
  };

  // >>>Handle Admin Logout<<<
  const handleLogOut = () => {
    toast.success("Logout SuccessFull");
    localStorage.clear();
    navigate("/login");
  };

  useEffect(() => {
    fetchAdminLoginData();
  }, []);

  // const data = useSelector((state)=>{
  //   return state.sidebar.isOpen
  //  })
  // const ShowSidebar = () =>{
  //   dispatch(toggleSidebar())
  //   console.log("GTR23")
  // }
  const { isOpen, unreadRemarks } = useSelector((state) => state.sidebar);

  const [filteredUnreadRemarks, setFilteredUnreadRemarks] = useState(0);

  useEffect(() => {
    let filteredUnreadRemarks = unreadRemarks;

    if (userCity) {
      filteredUnreadRemarks = unreadRemarks.filter(
        (item) => item?.Property?.city?._id === userCity,
      );
    }

    setFilteredUnreadRemarks(filteredUnreadRemarks?.length);
    console.log("VGL76", filteredUnreadRemarks, userCity);
  }, [unreadRemarks]);

  useEffect(() => {
    dispatch(fetchRemarksOnProperty());
  }, []);

  return (
    <>
      <div className={`sidebarwrap ${isOpen ? "show" : ""}`}>
        {/* <i onClick={ShowSidebar} class="fa-solid fa-caret-left"></i> */}
        <i
          style={{
            position: "absolute",
            top: "0px",
            right: "0px",
            color: "rgb(133, 218, 79)",
            cursor: "pointer",
            fontSize: "35px",
          }}
          class="fa-solid fa-caret-left left_arrow"
          onClick={HideSidebar}
        ></i>
        <div className="sidebar_logo_div">
          <p
            style={{
              color: "#fff",
              fontSize: "30px",
              fontWeight: "600",
              textAlign: "left",
              marginTop: "20px",
              marginLeft: "20px",
            }}
          >
            <span
              style={{
                color: "rgb(172, 216, 65)",
              }}
            >
              Win
            </span>
            ners
          </p>
        </div>
        <p
          style={{
            color: "#fff",
            fontSize: "15px",
            fontWeight: "600",
            textAlign: "left",
            marginTop: "20px",
            marginLeft: "15px",
          }}
        >
          MENU
        </p>
        <div className="sidebar_menu">
          <ul className="nav Menu_Nav accordion" id="sidemenu">
            {/* **Menu 1 Dashboard** */}
            <li
              className="menuline"
              style={{
                display:
                  localStorage?.getItem("role") === "survey" ? "none" : "",
              }}
            >
              <NavLink to="/" className="" onClick={handlClick}>
                <i class="fa-solid fa-cubes"></i>
                <span>Dashboard</span>
              </NavLink>
            </li>
            {/* **Menu 2 City** */}
            <li
              className="menuline"
              style={{
                display: ["superadmin", "branch manager"].includes(userRole)
                  ? "block"
                  : "none",
              }}
            >
              <div className="menu-head" id="sidemenuhead2">
                <Link
                  to="#"
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu2"
                  aria-expanded="true"
                  aria-controls="sidemenu2"
                >
                  <i class="fa-solid fa-city"></i>
                  <span>City</span>
                </Link>
              </div>
              <div
                id="sidemenu2"
                className="collapse"
                aria-labelledby="sidemenuhead2"
                data-parent="#sidemenu"
              >
                <ul className="Submenu">
                  <li
                    style={{
                      display: `${
                        userRole === "branch manager" ? "none" : null
                      }`,
                    }}
                  >
                    <NavLink to="/add-city" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>
                      Add City
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/manage-city" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Manage
                      City
                    </NavLink>
                  </li>
                </ul>
              </div>
            </li>
            {/* City Details */}
            <li
              className="menuline"
              style={{
                display: ["superadmin", "branch manager"].includes(userRole)
                  ? "block"
                  : "none",
              }}
            >
              <div className="menu-head" id="sidemenuhead12">
                <Link
                  to="#"
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu12"
                  aria-expanded="true"
                  aria-controls="sidemenu12"
                >
                  <i class="fa-solid fa-city"></i>
                  <span>City Details</span>
                </Link>
              </div>
              <div
                id="sidemenu12"
                className="collapse"
                aria-labelledby="sidemenuhead12"
                data-parent="#sidemenu"
              >
                <ul className="Submenu">
                  <li
                    style={{
                      display: `${
                        userRole === "branch manager" ? "none" : null
                      }`,
                    }}
                  >
                    <NavLink to="/add-city-details" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>
                      Add City Details
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/manage-city-details" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Manage
                      City Details
                    </NavLink>
                  </li>
                </ul>
              </div>
            </li>
            {/* Locality */}
            <li
              className="menuline"
              style={{
                display: ["superadmin", "branch manager"].includes(userRole)
                  ? "block"
                  : "none",
              }}
            >
              <div className="menu-head" id="sidemenuhead-locality">
                <Link
                  to="#"
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu-locality"
                  aria-expanded="true"
                  aria-controls="sidemenu-locality"
                >
                  {/* <span style={{ fontSize: "20px" }}>+</span> */}
                  <i class="fa-solid fa-map-marker-alt"></i>
                  <span>Locality</span>
                </Link>
              </div>
              <div
                id="sidemenu-locality"
                className="collapse"
                aria-labelledby="sidemenuhead-locality"
                data-parent="#sidemenu"
              >
                <ul className="Submenu">
                  <li>
                    <NavLink to="/add-locality" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Add
                      Locality
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/manage-locality" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Manage
                      Locality
                    </NavLink>
                  </li>
                </ul>
              </div>
            </li>
            {/* Apartment */}
            <li
              className="menuline"
              style={{
                display: ["superadmin", "branch manager"].includes(userRole)
                  ? "block"
                  : "none",
              }}
            >
              <div className="menu-head" id="sidemenuhead-apartment">
                <Link
                  to="#"
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu-apartment"
                  aria-expanded="true"
                  aria-controls="sidemenu-apartment"
                >
                  {/* <span style={{ fontSize: "20px" }}>+</span> */}
                  <i class="fa-solid fa-building"></i>
                  <span>Apartment</span>
                </Link>
              </div>
              <div
                id="sidemenu-apartment"
                className="collapse"
                aria-labelledby="sidemenuhead-apartment"
                data-parent="#sidemenu"
              >
                <ul className="Submenu">
                  <li>
                    <NavLink to="/add-apartment" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Add
                      Apartment
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/manage-apartment" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Manage
                      Apartment
                    </NavLink>
                  </li>
                </ul>
              </div>
            </li>
            {/* **Menu 3 Property Type** */}
            <li
              className="menuline"
              style={{
                display: [
                  "superadmin",
                  "branch manager",
                  "telecalling",
                  "data entry",
                ].includes(userRole)
                  ? "block"
                  : "none",
              }}
            >
              <div className="menu-head" id="sidemenuhead3">
                <Link
                  to="#"
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu3"
                  aria-expanded="true"
                  aria-controls="sidemenu3"
                >
                  <i class="fa-solid fa-key"></i>
                  <span>Property Type</span>
                </Link>
              </div>
              <div
                id="sidemenu3"
                className="collapse"
                aria-labelledby="sidemenuhead3"
                data-parent="#sidemenu"
              >
                <ul className="Submenu">
                  <li>
                    <NavLink to="/add-property-type" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Add
                      Property Type
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/manage-property-type" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Manage
                      Property Type
                    </NavLink>
                  </li>
                </ul>
              </div>
            </li>
            {/* **Menu  Facing** */}
            <li
              className="menuline"
              style={{
                display: [
                  "superadmin",
                  "branch manager",
                  "telecalling",
                  "data entry",
                ].includes(userRole)
                  ? "block"
                  : "none",
              }}
            >
              <div className="menu-head" id="sidemenuhead11">
                <Link
                  to="#"
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu11"
                  aria-expanded="true"
                  aria-controls="sidemenu11"
                >
                  <i class="fa-solid fa-compass"></i>
                  <span>Facing</span>
                </Link>
              </div>
              <div
                id="sidemenu11"
                className="collapse"
                aria-labelledby="sidemenuhead10"
                data-parent="#sidemenu"
              >
                <ul className="Submenu">
                  <li>
                    <NavLink to="/add-facing" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Add
                      Facing
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/manage-facing" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Manage
                      Facing
                    </NavLink>
                  </li>
                </ul>
              </div>
            </li>
            {/* **Menu 6 Property ** */}
            <li
              className="menuline"
              style={{
                display: [
                  "superadmin",
                  "branch manager",
                  "telecalling",
                  "data entry",
                  "survey",
                ].includes(userRole)
                  ? "block"
                  : "none",
              }}
            >
              <div className="menu-head" id="sidemenuhead6">
                <Link
                  to="#"
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu6"
                  aria-expanded="true"
                  aria-controls="sidemenu6"
                >
                  <i class="fa-solid fa-house"></i>
                  <span>Property</span>
                </Link>
              </div>
              <div
                id="sidemenu6"
                className="collapse"
                aria-labelledby="sidemenuhead6"
                data-parent="#sidemenu"
              >
                <ul className="Submenu">
                  <li>
                    <NavLink to="/add-property" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Add
                      Property
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/manage-property" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Manage
                      Property
                    </NavLink>
                  </li>
                </ul>
              </div>
            </li>
            {/* **Menu  Banner** */}
            <li
              className="menuline"
              style={{
                display: ["superadmin", "branch manager"].includes(userRole)
                  ? "block"
                  : "none",
              }}
            >
              <div className="menu-head" id="sidemenuhead9">
                <Link
                  to="#"
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu9"
                  aria-expanded="true"
                  aria-controls="sidemenu9"
                >
                  <i class="fa-solid fa-bolt"></i>
                  <span>Banner</span>
                </Link>
              </div>
              <div
                id="sidemenu9"
                className="collapse"
                aria-labelledby="sidemenuhead9"
                data-parent="#sidemenu"
              >
                <ul className="Submenu">
                  <li>
                    <NavLink to="/add-banner" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Add
                      Banner
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/manage-banner" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Manage
                      Banner
                    </NavLink>
                  </li>
                </ul>
              </div>
            </li>
            {/* Staff */}
            <li
              className="menuline"
              style={{
                display: ["superadmin", "branch manager"].includes(userRole)
                  ? "block"
                  : "none",
              }}
            >
              <div className="menu-head" id="sidemenuhead-staff">
                <Link
                  to="#"
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu-staff"
                  aria-expanded="true"
                  aria-controls="sidemenu-staff"
                >
                  <i class="fa-solid fa-id-badge"></i>
                  <span>Staff</span>
                </Link>
              </div>
              <div
                id="sidemenu-staff"
                className="collapse"
                aria-labelledby="sidemenuhead-staff"
                data-parent="#sidemenu"
              >
                <ul className="Submenu">
                  <li>
                    <NavLink to="/add-staff" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Add Staff
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/manage-staff" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Manage
                      Staff
                    </NavLink>
                  </li>
                </ul>
              </div>
            </li>
            {/* Designation */}
            <li
              className="menuline"
              style={{
                display: ["superadmin", "branch manager"].includes(userRole)
                  ? "block"
                  : "none",
              }}
            >
              <div className="menu-head" id="sidemenuhead-designation">
                <Link
                  to="#"
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu-designation"
                  aria-expanded="true"
                  aria-controls="sidemenu-designation"
                >
                  <i class="fa-solid fa-user-shield"></i>
                  <span>Designation</span>
                </Link>
              </div>
              <div
                id="sidemenu-designation"
                className="collapse"
                aria-labelledby="sidemenuhead-designation"
                data-parent="#sidemenu"
              >
                <ul className="Submenu">
                  <li>
                    <NavLink to="/add-designation" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Add
                      Designation
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/manage-designation" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Manage
                      Designation
                    </NavLink>
                  </li>
                </ul>
              </div>
            </li>
            {/* User */}
            <li
              className="menuline"
              style={{
                display: [
                  "superadmin",
                  "branch manager",
                  "sales",
                  "survey",
                  "telecalling",
                  "data entry",
                ].includes(userRole)
                  ? "block"
                  : "none",
              }}
            >
              <div className="menu-head" id="sidemenuhead-user">
                <Link
                  to="#"
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu-user"
                  aria-expanded="true"
                  aria-controls="sidemenu-user"
                >
                  <i class="fa-solid fa-user"></i>
                  <span>User</span>
                </Link>
              </div>
              <div
                id="sidemenu-user"
                className="collapse"
                aria-labelledby="sidemenuhead-user"
                data-parent="#sidemenu"
              >
                <ul className="Submenu">
                  <li>
                    <NavLink to="/add-user" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Add User
                    </NavLink>
                  </li>
                  <li
                    style={{
                      display:
                        localStorage?.getItem("role") === "survey" ||
                        localStorage?.getItem("role") === "data entry" ||
                        localStorage?.getItem("role") === "telecalling"
                          ? "none"
                          : "",
                    }}
                  >
                    <NavLink to="/manage-user" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Manage
                      User
                    </NavLink>
                  </li>
                </ul>
              </div>
            </li>
            {/* Basic User */}
            <li
              className="menuline"
              style={{
                display: [
                  "superadmin",
                  "branch manager",
                  "sales",
                  "survey",
                  "telecalling",
                  "data entry",
                ].includes(userRole)
                  ? "block"
                  : "none",
              }}
            >
              <div className="menu-head" id="sidemenuhead-basic-user">
                <Link
                  to="#"
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu-basic-user"
                  aria-expanded="true"
                  aria-controls="sidemenu-basic-user"
                >
                  <i className="fa-solid fa-user"></i>
                  <span>Basic User</span>
                </Link>
              </div>
              <div
                id="sidemenu-basic-user"
                className="collapse"
                aria-labelledby="sidemenuhead-basic-user"
                data-parent="#sidemenu"
              >
                <ul className="Submenu">
                  <li>
                    <NavLink to="/add-basic-user" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Add Basic User
                    </NavLink>
                  </li>
                  <li
                    style={{
                      display:
                        localStorage?.getItem("role") === "survey" ||
                        localStorage?.getItem("role") === "data entry" ||
                        localStorage?.getItem("role") === "telecalling"
                          ? "none"
                          : "",
                    }}
                  >
                    <NavLink to="/manage-basic-user" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Manage Basic User
                    </NavLink>
                  </li>
                </ul>
              </div>
            </li>
            {/* **Menu  Sales** */}
            <li
              className="menuline"
              style={{
                display: [
                  "superadmin",
                  "branch manager",
                  "sales",
                  "survey",
                ].includes(userRole)
                  ? "block"
                  : "none",
              }}
            >
              <div
                className="menu-head"
                id="sidemenuhead7"
                style={{
                  display:
                    localStorage?.getItem("role") === "survey" ? "none" : "",
                }}
              >
                <Link
                  // to="/sales"
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu25"
                  aria-expanded="true"
                  aria-controls="sidemenu25"
                  onClick={() => {
                    setoggle(!toggle);
                  }}
                >
                  <i class="fa-solid fa-piggy-bank"></i>
                  <span
                    className="d-flex justify-content-between align-items-center"
                    style={{
                      columnGap: "120px",
                    }}
                  >
                    Sales{" "}
                    <i
                      class={`fa-solid fa-caret-${toggle ? "up" : "down"}`}
                    ></i>
                  </span>
                </Link>
              </div>

              {/* Subscription */}
              {toggle && (
                <div
                  className="menuline"
                  style={{
                    // display: ["superadmin", "branch manager", "sales"].includes(userRole) ? "block" : "none",
                    paddingLeft: "15px",
                  }}
                >
                  <div className="menu-head" id="sidemenuhead8">
                    <Link
                      to="#"
                      className="btn btn-header-link"
                      data-toggle="collapse"
                      data-target="#sidemenu8"
                      aria-expanded="true"
                      aria-controls="sidemenu8"
                    >
                      <i class="fa-solid fa-indian-rupee-sign"></i>
                      <span>Subscription</span>
                    </Link>
                  </div>
                  <div
                    id="sidemenu8"
                    className="collapse"
                    aria-labelledby="sidemenuhead8"
                    data-parent="#sidemenu"
                  >
                    <ul className="Submenu">
                      <li>
                        <NavLink to="/add-subscription" onClick={handlClick}>
                          <i className="fa-solid fa-angles-right mr-2"></i>Add
                          Subscription
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/manage-subscription" onClick={handlClick}>
                          <i className="fa-solid fa-angles-right mr-2"></i>
                          Manage Subscription
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </div>
              )}

              {/* Advertisement */}
              {toggle && (
                <div
                  className="menuline"
                  style={{
                    // display: ["superadmin", "branch manager", "sales"].includes(userRole) ? "block" : "none",
                    paddingLeft: "15px",
                  }}
                >
                  <div className="menu-head" id="sidemenuhead10">
                    <Link
                      to="#"
                      className="btn btn-header-link"
                      data-toggle="collapse"
                      data-target="#sidemenu10"
                      aria-expanded="true"
                      aria-controls="sidemenu10"
                    >
                      <i class="fa-solid fa-rectangle-ad"></i>
                      <span>Advertisement</span>
                    </Link>
                  </div>
                  <div
                    id="sidemenu10"
                    className="collapse"
                    aria-labelledby="sidemenuhead10"
                    data-parent="#sidemenu"
                  >
                    <ul className="Submenu">
                      <li>
                        <NavLink to="/add-advertisement" onClick={handlClick}>
                          <i className="fa-solid fa-angles-right mr-2"></i>Add
                          Advertisement
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/manage-advertisement"
                          onClick={handlClick}
                        >
                          <i className="fa-solid fa-angles-right mr-2"></i>
                          Manage Advertisement
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </div>
              )}

              {/* Society */}
              {toggle && (
                <div
                  className="menuline"
                  style={{
                    // display: ["superadmin", "branch manager", "sales"].includes(userRole) ? "block" : "none",
                    paddingLeft: "15px",
                  }}
                >
                  <div className="menu-head" id="sidemenuhead-socity">
                    <Link
                      to="#"
                      className="btn btn-header-link"
                      data-toggle="collapse"
                      data-target="#sidemenu-socity"
                      aria-expanded="true"
                      aria-controls="sidemenu-socity"
                    >
                      <i class="fa-solid fa-hands-helping"></i>
                      <span>Society</span>
                    </Link>
                  </div>
                  <div
                    id="sidemenu-socity"
                    className="collapse"
                    aria-labelledby="sidemenuhead-socity"
                    data-parent="#sidemenu"
                  >
                    <ul className="Submenu">
                      <li>
                        <NavLink to="/add-society" onClick={handlClick}>
                          <i className="fa-solid fa-angles-right mr-2"></i>Add
                          Society
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/manage-society" onClick={handlClick}>
                          <i className="fa-solid fa-angles-right mr-2"></i>
                          Manage Society
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </div>
              )}

              {/* Community */}
              {toggle && (
                <div
                  className="menuline"
                  style={{
                    // display: ["superadmin", "branch manager", "sales"].includes(userRole) ? "block" : "none",
                    paddingLeft: "15px",
                  }}
                >
                  <div className="menu-head" id="sidemenuhead-community">
                    <Link
                      to="#"
                      className="btn btn-header-link"
                      data-toggle="collapse"
                      data-target="#sidemenu-community"
                      aria-expanded="true"
                      aria-controls="sidemenu-community"
                    >
                      <i class="fa-solid fa-people-group"></i>
                      <span>Community</span>
                    </Link>
                  </div>
                  <div
                    id="sidemenu-community"
                    className="collapse"
                    aria-labelledby="sidemenuhead-community"
                    data-parent="#sidemenu"
                  >
                    <ul className="Submenu">
                      <li>
                        <NavLink to="/add-community" onClick={handlClick}>
                          <i className="fa-solid fa-angles-right mr-2"></i>Add
                          Community
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/manage-community" onClick={handlClick}>
                          <i className="fa-solid fa-angles-right mr-2"></i>
                          Manage Community
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </div>
              )}

              {/* Inventory */}
              {toggle && (
                <div
                  className="menuline"
                  style={{
                    // display: ["superadmin", "branch manager", "sales"].includes(userRole) ? "block" : "none",
                    paddingLeft: "15px",
                  }}
                >
                  <div className="menu-head" id="sidemenuhead-inventory">
                    <Link
                      to="#"
                      className="btn btn-header-link"
                      data-toggle="collapse"
                      data-target="#sidemenu-inventory"
                      aria-expanded="true"
                      aria-controls="sidemenu-inventory"
                    >
                      <i class="fa-solid fa-boxes-stacked"></i>
                      <span>Inventory</span>
                    </Link>
                  </div>
                  <div
                    id="sidemenu-inventory"
                    className="collapse"
                    aria-labelledby="sidemenuhead-inventory"
                    data-parent="#sidemenu"
                  >
                    <ul className="Submenu">
                      <li>
                        <NavLink to="/add-inventory" onClick={handlClick}>
                          <i className="fa-solid fa-angles-right mr-2"></i>Add
                          Inventory
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/manage-inventory" onClick={handlClick}>
                          <i className="fa-solid fa-angles-right mr-2"></i>
                          Manage Inventory
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </div>
              )}
            </li>
            {/* {toggle && <li className="menuline"
              style={{
                display: ["superadmin", "branch manager", "sales"].includes(userRole) ? "block" : "none",
                paddingLeft: "25px",
              }}
            >
              <div className="menu-head" id="sidemenuhead8">
                <Link
                  to="#"
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu8"
                  aria-expanded="true"
                  aria-controls="sidemenu8"
                >

                  <i class="fa-solid fa-indian-rupee-sign"></i>
                  <span>Subscription</span>
                </Link>
              </div>
              <div
                id="sidemenu8"
                className="collapse"
                aria-labelledby="sidemenuhead8"
                data-parent="#sidemenu"
              >
                <ul className="Submenu">
                  <li>
                    <NavLink to="/add-subscription" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Add
                      Subscription
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/manage-subscription" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Manage
                      Subscription
                    </NavLink>
                  </li>
                </ul>
              </div>
            </li>} */}
            {/* **Sales Report** */}
            <li
              className="menuline"
              style={{
                display: ["superadmin", "branch manager"].includes(userRole)
                  ? "block"
                  : "none",
              }}
            >
              <NavLink to="/sales" className="" onClick={handlClick}>
                <i class="fa-solid fa-receipt"></i>
                <span>Sales Report</span>
              </NavLink>
            </li>
            {/* Expenses */}
            {/* **Menu  Sales** */}
            <li
              className="menuline"
              style={{
                display: ["superadmin", "branch manager"].includes(userRole)
                  ? "block"
                  : "none",
              }}
            >
              <div className="menu-head" id="sidemenuhead7">
                <Link
                  // to="/sales"
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu25"
                  aria-expanded="true"
                  aria-controls="sidemenu25"
                  onClick={() => {
                    setToggleExpenses(!toggleExpenses);
                  }}
                >
                  <i class="fa-solid fa-sack-xmark"></i>
                  <span
                    className="d-flex justify-content-between align-items-center"
                    style={{
                      columnGap: "90px",
                    }}
                  >
                    Expenses{" "}
                    <i
                      class={` margin-right fa-solid fa-caret-${
                        toggleExpenses ? "up" : "down"
                      }`}
                    ></i>
                  </span>
                </Link>
              </div>

              {/* Commission */}
              {toggleExpenses && (
                <div
                  className="menuline"
                  style={{
                    // display: ["superadmin", "branch manager", "sales"].includes(userRole) ? "block" : "none",
                    paddingLeft: "25px",
                  }}
                >
                  <div className="menu-head" id="sidemenuhead-commission">
                    <Link
                      to="#"
                      className="btn btn-header-link"
                      data-toggle="collapse"
                      data-target="#sidemenu-commission"
                      aria-expanded="true"
                      aria-controls="sidemenu-commission"
                    >
                      <i class="fa-solid fa-award"></i>
                      <span>Commission</span>
                    </Link>
                  </div>
                  <div
                    id="sidemenu-commission"
                    className="collapse"
                    aria-labelledby="sidemenuhead-commission"
                    data-parent="#sidemenu"
                  >
                    <ul className="Submenu">
                      <li>
                        <NavLink to="/add-commission" onClick={handlClick}>
                          <i className="fa-solid fa-angles-right mr-2"></i>Add
                          Commission
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/manage-commission" onClick={handlClick}>
                          <i className="fa-solid fa-angles-right mr-2"></i>
                          Manage Commission
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </div>
              )}

              {/* Salary */}
              {toggleExpenses && (
                <div
                  className="menuline"
                  style={{
                    // display: ["superadmin", "branch manager", "sales"].includes(userRole) ? "block" : "none",
                    paddingLeft: "25px",
                  }}
                >
                  <div className="menu-head" id="sidemenuhead-salary">
                    <Link
                      to="#"
                      className="btn btn-header-link"
                      data-toggle="collapse"
                      data-target="#sidemenu-salary"
                      aria-expanded="true"
                      aria-controls="sidemenu-salary"
                    >
                      <i class="fa-solid fa-wallet"></i>
                      <span>Salary</span>
                    </Link>
                  </div>
                  <div
                    id="sidemenu-salary"
                    className="collapse"
                    aria-labelledby="sidemenuhead-salary"
                    data-parent="#sidemenu"
                  >
                    <ul className="Submenu">
                      <li>
                        <NavLink to="/add-salary" onClick={handlClick}>
                          <i className="fa-solid fa-angles-right mr-2"></i>Add
                          Salary
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/manage-salary" onClick={handlClick}>
                          <i className="fa-solid fa-angles-right mr-2"></i>
                          Manage Salary
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </div>
              )}

              {/* Rent */}
              {toggleExpenses && (
                <div
                  className="menuline"
                  style={{
                    // display: ["superadmin", "branch manager", "sales"].includes(userRole) ? "block" : "none",
                    paddingLeft: "25px",
                  }}
                >
                  <div className="menu-head" id="sidemenuhead-rent">
                    <Link
                      to="#"
                      className="btn btn-header-link"
                      data-toggle="collapse"
                      data-target="#sidemenu-rent"
                      aria-expanded="true"
                      aria-controls="sidemenu-rent"
                    >
                      <i class="fa-solid fa-house-circle-check"></i>
                      <span>Rent</span>
                    </Link>
                  </div>
                  <div
                    id="sidemenu-rent"
                    className="collapse"
                    aria-labelledby="sidemenuhead-rent"
                    data-parent="#sidemenu"
                  >
                    <ul className="Submenu">
                      <li>
                        <NavLink to="/add-rent" onClick={handlClick}>
                          <i className="fa-solid fa-angles-right mr-2"></i>Add
                          Rent
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/manage-rent" onClick={handlClick}>
                          <i className="fa-solid fa-angles-right mr-2"></i>
                          Manage Rent
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </div>
              )}

              {/* Electricity */}
              {toggleExpenses && (
                <div
                  className="menuline"
                  style={{
                    // display: ["superadmin", "branch manager", "sales"].includes(userRole) ? "block" : "none",
                    paddingLeft: "25px",
                  }}
                >
                  <div className="menu-head" id="sidemenuhead-electricity">
                    <Link
                      to="#"
                      className="btn btn-header-link"
                      data-toggle="collapse"
                      data-target="#sidemenu-electricity"
                      aria-expanded="true"
                      aria-controls="sidemenu-electricity"
                    >
                      <i class="fa-solid fa-lightbulb"></i>
                      <span>Electricity</span>
                    </Link>
                  </div>
                  <div
                    id="sidemenu-electricity"
                    className="collapse"
                    aria-labelledby="sidemenuhead-electricity"
                    data-parent="#sidemenu"
                  >
                    <ul className="Submenu">
                      <li>
                        <NavLink to="/add-electricity" onClick={handlClick}>
                          <i className="fa-solid fa-angles-right mr-2"></i>Add
                          Electricity
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/manage-electricity" onClick={handlClick}>
                          <i className="fa-solid fa-angles-right mr-2"></i>
                          Manage Electricity
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </div>
              )}

              {/* Telephone & Internet */}
              {toggleExpenses && (
                <div
                  className="menuline"
                  style={{
                    // display: ["superadmin", "branch manager", "sales"].includes(userRole) ? "block" : "none",
                    paddingLeft: "25px",
                  }}
                >
                  <div
                    className="menu-head"
                    id="sidemenuhead-telephone-n-internet"
                  >
                    <Link
                      to="#"
                      className="btn btn-header-link"
                      data-toggle="collapse"
                      data-target="#sidemenu-telephone-n-internet"
                      aria-expanded="true"
                      aria-controls="sidemenu-telephone-n-internet"
                    >
                      <i class="fa-solid fa-wifi"></i>
                      <span>Telephone & Internet</span>
                    </Link>
                  </div>
                  <div
                    id="sidemenu-telephone-n-internet"
                    className="collapse"
                    aria-labelledby="sidemenuhead-telephone-n-internet"
                    data-parent="#sidemenu"
                  >
                    <ul className="Submenu">
                      <li>
                        <NavLink
                          to="/add-telephone-n-internet"
                          onClick={handlClick}
                        >
                          <i className="fa-solid fa-angles-right mr-2"></i>Add
                          Telephone & Internet
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/manage-telephone-n-internet"
                          onClick={handlClick}
                        >
                          <i className="fa-solid fa-angles-right mr-2"></i>
                          Manage Telephone & Internet
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </div>
              )}

              {/* Petrol */}
              {toggleExpenses && (
                <div
                  className="menuline"
                  style={{
                    // display: ["superadmin", "branch manager", "sales"].includes(userRole) ? "block" : "none",
                    paddingLeft: "25px",
                  }}
                >
                  <div className="menu-head" id="sidemenuhead-petrol">
                    <Link
                      to="#"
                      className="btn btn-header-link"
                      data-toggle="collapse"
                      data-target="#sidemenu-petrol"
                      aria-expanded="true"
                      aria-controls="sidemenu-petrol"
                    >
                      <i class="fa-solid fa-gas-pump"></i>
                      <span>Petrol</span>
                    </Link>
                  </div>
                  <div
                    id="sidemenu-petrol"
                    className="collapse"
                    aria-labelledby="sidemenuhead-petrol"
                    data-parent="#sidemenu"
                  >
                    <ul className="Submenu">
                      <li>
                        <NavLink to="/add-petrol" onClick={handlClick}>
                          <i className="fa-solid fa-angles-right mr-2"></i>Add
                          Petrol
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/manage-petrol" onClick={handlClick}>
                          <i className="fa-solid fa-angles-right mr-2"></i>
                          Manage Petrol
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </div>
              )}

              {/* Miscellaneous */}
              {toggleExpenses && (
                <div
                  className="menuline"
                  style={{
                    // display: ["superadmin", "branch manager", "sales"].includes(userRole) ? "block" : "none",
                    paddingLeft: "25px",
                  }}
                >
                  <div className="menu-head" id="sidemenuhead-miscellaneous">
                    <Link
                      to="#"
                      className="btn btn-header-link"
                      data-toggle="collapse"
                      data-target="#sidemenu-miscellaneous"
                      aria-expanded="true"
                      aria-controls="sidemenu-miscellaneous"
                    >
                      <i class="fa-solid fa-layer-group"></i>
                      <span>Miscellaneous</span>
                    </Link>
                  </div>
                  <div
                    id="sidemenu-miscellaneous"
                    className="collapse"
                    aria-labelledby="sidemenuhead-miscellaneous"
                    data-parent="#sidemenu"
                  >
                    <ul className="Submenu">
                      <li>
                        <NavLink to="/add-miscellaneous" onClick={handlClick}>
                          <i className="fa-solid fa-angles-right mr-2"></i>Add
                          Miscellaneous
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/manage-miscellaneous"
                          onClick={handlClick}
                        >
                          <i className="fa-solid fa-angles-right mr-2"></i>
                          Manage Miscellaneous
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </div>
              )}
            </li>
            {/* **Expense Report** */}
            <li
              className="menuline"
              style={{
                display: ["superadmin", "branch manager"].includes(userRole)
                  ? "block"
                  : "none",
              }}
            >
              <NavLink to="/expense-report" className="" onClick={handlClick}>
                <i class="fa-solid fa-file-alt"></i>
                <span>Expense Report</span>
              </NavLink>
            </li>
            {/* Send Email */}
            <li
              className="menuline"
              style={{
                display: ["superadmin", "branch manager"].includes(userRole)
                  ? "block"
                  : "none",
              }}
            >
              <div className="menu-head" id="sidemenuhead-sendemail">
                <Link
                  to="#"
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu-sendemail"
                  aria-expanded="true"
                  aria-controls="sidemenu-sendemail"
                >
                  <i class="fa-solid fa-paper-plane"></i>
                  <span>Send Mail</span>
                </Link>
              </div>
              <div
                id="sidemenu-sendemail"
                className="collapse"
                aria-labelledby="sidemenuhead-sendemail"
                data-parent="#sidemenu"
              >
                <ul className="Submenu">
                  <li>
                    <NavLink to="/send-email-to-staff" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Email to
                      Staff
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/sent-email-to-staff" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Staff
                      Emails History
                    </NavLink>
                  </li>
                </ul>
              </div>
            </li>
            {/* Hot Clients */}
            <li
              className="menuline"
              style={{
                display: ["superadmin", "branch manager"].includes(userRole)
                  ? "block"
                  : "none",
              }}
            >
              <NavLink to="/hot-clients" className="" onClick={handlClick}>
                <i class="fa-solid fa-briefcase"></i>
                <span>Hot Clients</span>
              </NavLink>
            </li>
            {/* Sales Pipeline / Lead */}
            <li
              className="menuline"
              style={{
                display: ["superadmin", "branch manager"].includes(userRole)
                  ? "block"
                  : "none",
              }}
            >
              <div className="menu-head" id="sidemenuhead-sales-pipeline">
                <Link
                  to="#"
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu-sales-pipeline"
                  aria-expanded="true"
                  aria-controls="sidemenu-sales-pipeline"
                >
                  <i class="fa-solid fa-filter"></i>
                  <span>Leads</span>
                </Link>
              </div>
              <div
                id="sidemenu-sales-pipeline"
                className="collapse"
                aria-labelledby="sidemenuhead-sales-pipeline"
                data-parent="#sidemenu"
              >
                <ul className="Submenu">
                  <li>
                    <NavLink to="/add-sales-pipeline" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Add Lead
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/manage-sales-pipeline" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Manage
                      Lead
                    </NavLink>
                  </li>
                </ul>
              </div>
            </li>
            <li
              className="menu-head"
              style={{
                display: [
                  "superadmin",
                  "sales",
                  // "survey",
                  "telecalling",
                  "data entry",
                  "branch manager",
                ].includes(userRole)
                  ? "block"
                  : "none",
              }}
            >
              <Link to="/work-sheet" className="">
                <i class="fa-solid fa-table"></i>
                <span>Work Sheet</span>
              </Link>
            </li>
            {/* Deleted Worksheet */}
            <li
              className="menu-head"
              style={{
                display: [
                  "superadmin",
                  "branch manager",
                  "telecalling",
                  "data entry",
                ].includes(userRole)
                  ? "block"
                  : "none",
              }}
            >
              <Link to="/deleted-worksheet" className="">
                <i class="fa-solid fa-table"></i>
                <span>Deleted Properties</span>
              </Link>
            </li>
            {/*Blog Section*/}
            <li
              className="menuline"
              style={{
                display: ["superadmin", "branch manager"].includes(userRole)
                  ? "block"
                  : "none",
              }}
            >
              <div className="menu-head" id="sidemenuhead2">
                <Link
                  to="#"
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu2"
                  aria-expanded="true"
                  aria-controls="sidemenu2"
                >
                  {/* <i class="fa-solid fa-city"></i> */}
                  <i class="fa fa-rss"></i>
                  <span>Blog</span>
                </Link>
              </div>
              <div
                id="sidemenu2"
                className="collapse"
                aria-labelledby="sidemenuhead2"
                data-parent="#sidemenu"
              >
                <ul className="Submenu">
                  <li>
                    <NavLink to="/add-blog-category" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>
                      Add Blog Category
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/manage-blog-category" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Manage
                      Blog Category
                    </NavLink>
                  </li>

                  <li>
                    <NavLink to="/add-blog" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>
                      Add Blog
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/manage-blog" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Manage
                      Blog
                    </NavLink>
                  </li>
                </ul>
              </div>
            </li>
            {/* Remarks on Property */}
            <li
              className="menu-head"
              style={{
                display: ["superadmin", "branch manager"].includes(userRole)
                  ? "block"
                  : "none",
                width: "100%",
              }}
            >
              <NavLink to="/remarks-on-property" className="">
                <i class="fa-solid fa-comments"></i>
                <span>Remarks</span>
                {filteredUnreadRemarks > 0 && (
                  <>
                    <span className="number-circle">
                      {filteredUnreadRemarks}
                    </span>
                  </>
                )}
              </NavLink>
            </li>
            {/* Deals */}
            <li
              className="menu-head"
              style={{
                display: ["superadmin", "branch manager"].includes(userRole)
                  ? "block"
                  : "none",
              }}
            >
              <Link to="/view-deals" className="">
                <i class="fa-solid fa-tags"></i>
                <span>Deals</span>
              </Link>
            </li>
            {/*Job*/}
            <li
              className="menuline"
              style={{
                display: ["superadmin", "branch manager"].includes(userRole)
                  ? "block"
                  : "none",
              }}
            >
              <div className="menu-head" id="sidemenuhead-job">
                <Link
                  to="#"
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu-job"
                  aria-expanded="true"
                  aria-controls="sidemenu-job"
                >
                  {/* <i class="fa-solid fa-city"></i> */}
                  <i class="fa fa-briefcase"></i>
                  <span>Job</span>
                </Link>
              </div>
              <div
                id="sidemenu-job"
                className="collapse"
                aria-labelledby="sidemenuhead-job"
                data-parent="#sidemenu"
              >
                <ul className="Submenu">
                  <li>
                    <NavLink to="/add-job-category" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>
                      Add Job Category
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/manage-job-category" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Manage
                      Job Category
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/add-job-post" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Add Job
                      Vacancy
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/manage-job-post" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Manage
                      Job Vacancy
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/job-applications" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>
                      Job Application(s)
                    </NavLink>
                  </li>
                </ul>
              </div>
            </li>
            {/*Promotion*/}
            <li
              className="menuline"
              style={{
                display: ["superadmin", "branch manager"].includes(userRole)
                  ? "block"
                  : "none",
              }}
            >
              <div className="menu-head" id="sidemenuhead-promotion">
                <Link
                  to="#"
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu-promotion"
                  aria-expanded="true"
                  aria-controls="sidemenu-promotion"
                >
                  {/* <i class="fa-solid fa-city"></i> */}
                  <i class="fa fa-gift"></i>
                  <span>Promotion</span>
                </Link>
              </div>
              <div
                id="sidemenu-promotion"
                className="collapse"
                aria-labelledby="sidemenuhead-promotion"
                data-parent="#sidemenu"
              >
                <ul className="Submenu">
                  <li>
                    <NavLink to="/add-promotion" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>
                      Add Promotion
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/manage-promotion" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Manage
                      Promotion
                    </NavLink>
                  </li>
                </ul>
              </div>
            </li>
            {/*Reels*/}
            {/* <li
              className="menuline"
              style={{
                display: [
                  "superadmin",
                  "branch manager",
                  "telecalling",
                  "data entry",
                  "survey",
                ].includes(userRole)
                  ? "block"
                  : "none",
              }}
            >
              <div className="menu-head" id="sidemenuhead6">
                <Link
                  to="#"
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu19"
                  aria-expanded="true"
                  aria-controls="sidemenu19"
                >
                  <i class="fa-solid fa-house"></i>
                  <span>Reels</span>
                </Link>
              </div>
              <div
                id="sidemenu19"
                className="collapse"
                aria-labelledby="sidemenuhead19"
                data-parent="#sidemenu"
              >
                <ul className="Submenu">
                  <li>
                    <NavLink to="/add-reels" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Add Reels
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/manage-reels" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Manage
                      Reels
                    </NavLink>
                  </li>
                </ul>
              </div>
            </li> */}
            {/*Reels*/}
            <li
              className="menuline"
              style={{
                display: [
                  "superadmin",
                  "branch manager",
                  "telecalling",
                  "data entry",
                  "survey",
                ].includes(userRole)
                  ? "block"
                  : "none",
              }}
            >
              <div className="menu-head" id="sidemenuhead-reels">
                <Link
                  to="#"
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu-reels"
                  aria-expanded="true"
                  aria-controls="sidemenu-reels"
                >
                  <i class="fa-solid fa-film"></i>
                  <span>Reels</span>
                </Link>
              </div>
              <div
                id="sidemenu-reels"
                className="collapse"
                aria-labelledby="sidemenuhead-reels"
                data-parent="#sidemenu"
              >
                <ul className="Submenu">
                  <li>
                    <NavLink to="/add-reels" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Add Reels
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/manage-reels" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Manage
                      Reels
                    </NavLink>
                  </li>
                </ul>
              </div>
            </li>
            {/*Advertisement For Cities*/}
            <li
              className="menuline"
              style={{
                display: [
                  "superadmin",
                  "branch manager",
                  "telecalling",
                  "data entry",
                  "survey",
                ].includes(userRole)
                  ? "block"
                  : "none",
              }}
            >
              <div className="menu-head" id="sidemenuhead-personalservice">
                <Link
                  to="#"
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu-advertisementnew"
                  aria-expanded="true"
                  aria-controls="sidemenu-advertisementnew"
                >
                  <i class="fa-solid fa-film"></i>
                  <span>Advertisement For Cities</span>
                </Link>
              </div>
              <div
                id="sidemenu-advertisementnew"
                className="collapse"
                aria-labelledby="sidemenuhead-advertisementnew"
                data-parent="#sidemenu"
              >
                <ul className="Submenu">
                  <li>
                    <NavLink
                      to="/add-advertisement-for-city"
                      onClick={handlClick}
                    >
                      <i className="fa-solid fa-angles-right mr-2"></i>Add
                      Advertisement
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/manage-advertisement-for-city"
                      onClick={handlClick}
                    >
                      <i className="fa-solid fa-angles-right mr-2"></i>Manage
                      Advertisement
                    </NavLink>
                  </li>
                </ul>
              </div>
            </li>
            {/* Advertisement Showing Order */}
            <li
              className="menuline"
              style={{
                display: [
                  "superadmin",
                  "branch manager",
                  "telecalling",
                  "data entry",
                  "survey",
                ].includes(userRole)
                  ? "block"
                  : "none",
              }}
            >
              <div
                className="menu-head"
                id="sidemenuhead-advertisementshowingorder"
              >
                <Link
                  to="#"
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu-advertisementshowingorder"
                  aria-expanded="true"
                  aria-controls="sidemenu-advertisementshowingorder"
                >
                  <i class="fa-solid fa-film"></i>
                  <span>Advertisement Showing Order</span>
                </Link>
              </div>
              <div
                id="sidemenu-advertisementshowingorder"
                className="collapse"
                aria-labelledby="sidemenuhead-advertisementshowingorder"
                data-parent="#sidemenu"
              >
                <ul className="Submenu">
                  {/* <li>
                    <NavLink
                      to="/add-advertisement-showing-order"
                      onClick={handlClick}
                    >
                      <i className="fa-solid fa-angles-right mr-2"></i>Add Order
                    </NavLink>
                  </li> */}
                  <li>
                    <NavLink
                      to="/manage-advertisement-showing-order"
                      onClick={handlClick}
                    >
                      <i className="fa-solid fa-angles-right mr-2"></i>Manage
                      Order
                    </NavLink>
                  </li>
                </ul>
              </div>
            </li>
            {/* view report property */}
            <li
              className="menuline"
              style={{
                display:
                  localStorage?.getItem("role") === "survey" ? "none" : "",
              }}
            >
              <NavLink
                to="/view-report-property"
                className=""
                onClick={handlClick}
              >
                <i class="fa-solid fa-cubes"></i>
                <span>View Report Property</span>
              </NavLink>
            </li>
            {/* prime location insights */}
            <li
              className="menuline"
              style={{
                display: [
                  "superadmin",
                  "branch manager",
                  "telecalling",
                  "data entry",
                  "survey",
                ].includes(userRole)
                  ? "block"
                  : "none",
              }}
            >
              <div className="menu-head" id="sidemenuhead-personalservice">
                <Link
                  to="#"
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu-primeLocation"
                  aria-expanded="true"
                  aria-controls="sidemenu-primeLocation"
                >
                  <i class="fa-solid fa-film"></i>
                  <span>Prime Location Insights</span>
                </Link>
              </div>
              <div
                id="sidemenu-primeLocation"
                className="collapse"
                aria-labelledby="sidemenuhead-primeLocation"
                data-parent="#sidemenu"
              >
                <ul className="Submenu">
                  <li>
                    <NavLink
                      to="/add-prime-location-insights"
                      onClick={handlClick}
                    >
                      <i className="fa-solid fa-angles-right mr-2"></i>Add Prime
                      Location
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/manage-prime-location-insights"
                      onClick={handlClick}
                    >
                      <i className="fa-solid fa-angles-right mr-2"></i>Manage
                      Prime Location
                    </NavLink>
                  </li>
                </ul>
              </div>
            </li>
            {/* Highlighted Projects */}

            <li
              className="menuline"
              style={{
                display: [
                  "superadmin",
                  "branch manager",
                  "telecalling",
                  "data entry",
                  "survey",
                ].includes(userRole)
                  ? "block"
                  : "none",
              }}
            >
              <div className="menu-head" id="sidemenuhead-personalservice">
                <Link
                  to="#"
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu-highlightedproject"
                  aria-expanded="true"
                  aria-controls="sidemenu-highlightedproject"
                >
                  <i class="fa-solid fa-film"></i>
                  <span>Highlighted Project Section</span>
                </Link>
              </div>
              <div
                id="sidemenu-highlightedproject"
                className="collapse"
                aria-labelledby="sidemenuhead-highlightedproject"
                data-parent="#sidemenu"
              >
                <ul className="Submenu">
                  <li>
                    <NavLink to="/add-highlighted-project" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Add
                      Highlighted Project
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/manage-highlighted-project"
                      onClick={handlClick}
                    >
                      <i className="fa-solid fa-angles-right mr-2"></i>Manage
                      Highlighted Project
                    </NavLink>
                  </li>
                </ul>
              </div>
            </li>

            {/* Dealers */}
            <li
              className="menuline"
              style={{
                display: [
                  "superadmin",
                  "branch manager",
                  "telecalling",
                  "data entry",
                  "survey",
                ].includes(userRole)
                  ? "block"
                  : "none",
              }}
            >
              <div className="menu-head" id="sidemenuhead-personalservice">
                <Link
                  to="#"
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu-dealer"
                  aria-expanded="true"
                  aria-controls="sidemenu-dealer"
                >
                  <i class="fa-solid fa-film"></i>
                  <span>Dealer Section</span>
                </Link>
              </div>
              <div
                id="sidemenu-dealer"
                className="collapse"
                aria-labelledby="sidemenuhead-dealer"
                data-parent="#sidemenu"
              >
                <ul className="Submenu">
                  <li>
                    <NavLink to="/add-dealer-section" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Add
                      Dealer Section
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/manage-dealer-section" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Manage
                      Dealer Section
                    </NavLink>
                  </li>
                </ul>
              </div>
            </li>
            {/* Personal Service */}
            {/* <li
              className="menuline"
              style={{
                display: [
                  "superadmin",
                  "branch manager",
                  "telecalling",
                  "data entry",
                  "survey",
                ].includes(userRole)
                  ? "block"
                  : "none",
              }}
            >
              <div className="menu-head" id="sidemenuhead-personalservice">
                <Link
                  to="#"
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu-personalservice"
                  aria-expanded="true"
                  aria-controls="sidemenu-personalservice"
                >
                  <i class="fa-solid fa-film"></i>
                  <span>Personal Service</span>
                </Link>
              </div>
              <div
                id="sidemenu-personalservice"
                className="collapse"
                aria-labelledby="sidemenuhead-personalservice"
                data-parent="#sidemenu"
              >
                <ul className="Submenu">
                  <li>
                    <NavLink to="/add-personal-service" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Add
                      Personal Service
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/manage-personal-service" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Manage
                      Personal Service
                    </NavLink>
                  </li>
                </ul>
              </div>
            </li> */}
            {/* Wall of Fame */}
            <li
              className="menuline"
              style={{
                display: [
                  "superadmin",
                  "branch manager",
                  "telecalling",
                  "data entry",
                  "survey",
                ].includes(userRole)
                  ? "block"
                  : "none",
              }}
            >
              <div className="menu-head" id="sidemenuhead-walloffame">
                <Link
                  to="#"
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu-walloffame"
                  aria-expanded="true"
                  aria-controls="sidemenu-walloffame"
                >
                  <i class="fa-solid fa-film"></i>
                  <span>Wall of Fame</span>
                </Link>
              </div>
              <div
                id="sidemenu-walloffame"
                className="collapse"
                aria-labelledby="sidemenuhead-walloffame"
                data-parent="#sidemenu"
              >
                <ul className="Submenu">
                  <li>
                    <NavLink to="/add-wall-of-fame" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Add Wall
                      of Fame
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/manage-wall-of-fame" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Manage
                      Wall of Fame
                    </NavLink>
                  </li>
                </ul>
              </div>
            </li>
            {/* people saying */}
            <li
              className="menuline"
              style={{
                display: [
                  "superadmin",
                  "branch manager",
                  "telecalling",
                  "data entry",
                  "survey",
                ].includes(userRole)
                  ? "block"
                  : "none",
              }}
            >
              <div className="menu-head" id="sidemenuhead-peoplesaying">
                <Link
                  to="#"
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu-peoplesaying"
                  aria-expanded="true"
                  aria-controls="sidemenu-peoplesaying"
                >
                  <i class="fa-solid fa-film"></i>
                  <span>People Saying</span>
                </Link>
              </div>
              <div
                id="sidemenu-peoplesaying"
                className="collapse"
                aria-labelledby="sidemenuhead-peoplesaying"
                data-parent="#sidemenu"
              >
                <ul className="Submenu">
                  <li>
                    <NavLink to="/add-people-saying" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Add
                      People Saying
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/manage-people-saying" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Manage
                      People Saying
                    </NavLink>
                  </li>
                </ul>
              </div>
            </li>
            {/* FAQ */}
            <li
              className="menuline"
              style={{
                display: [
                  "superadmin",
                  "branch manager",
                  "telecalling",
                  "data entry",
                  "survey",
                ].includes(userRole)
                  ? "block"
                  : "none",
              }}
            >
              <div className="menu-head" id="sidemenuhead-faq">
                <Link
                  to="#"
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu-faq"
                  aria-expanded="true"
                  aria-controls="sidemenu-faq"
                >
                  <i class="fa-solid fa-film"></i>
                  <span>FAQ</span>
                </Link>
              </div>
              <div
                id="sidemenu-faq"
                className="collapse"
                aria-labelledby="sidemenuhead-faq"
                data-parent="#sidemenu"
              >
                <ul className="Submenu">
                  <li>
                    <NavLink to="/add-faq" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Add FAQ
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/manage-faq" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Manage
                      FAQ
                    </NavLink>
                  </li>
                </ul>
              </div>
            </li>
            {/* App poster */}
            <li
              className="menuline"
              style={{
                display: [
                  "superadmin",
                  "branch manager",
                  "telecalling",
                  "data entry",
                  "survey",
                ].includes(userRole)
                  ? "block"
                  : "none",
              }}
            >
              <div className="menu-head" id="sidemenuhead-appposter">
                <Link
                  to="#"
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu-appposter"
                  aria-expanded="true"
                  aria-controls="sidemenu-appposter"
                >
                  <i class="fa-solid fa-film"></i>
                  <span>App Poster</span>
                </Link>
              </div>
              <div
                id="sidemenu-appposter"
                className="collapse"
                aria-labelledby="sidemenuhead-appposter"
                data-parent="#sidemenu"
              >
                <ul className="Submenu">
                  {/* <li>
                    <NavLink to="/add-app-poster" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Add App
                      Poster
                    </NavLink>
                  </li> */}
                  <li>
                    <NavLink to="/manage-app-poster" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Manage
                      App Poster
                    </NavLink>
                  </li>
                </ul>
              </div>
            </li>
            {/* City With Date */}
            <li
              className="menuline"
              style={{
                display: [
                  "superadmin",
                  "branch manager",
                  "telecalling",
                  "data entry",
                  "survey",
                ].includes(userRole)
                  ? "block"
                  : "none",
              }}
            >
              <div className="menu-head" id="sidemenuhead-citydate">
                <Link
                  to="#"
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu-citydate"
                  aria-expanded="true"
                  aria-controls="sidemenu-citydate"
                >
                  <i className="fa-solid fa-calendar-days"></i>
                  <span>City With Date</span>
                </Link>
              </div>
              <div
                id="sidemenu-citydate"
                className="collapse"
                aria-labelledby="sidemenuhead-citydate"
                data-parent="#sidemenu"
              >
                <ul className="Submenu">
                  <li>
                    <NavLink to="/add-city-date" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Add
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/manage-city-date" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Manage
                    </NavLink>
                  </li>
                </ul>
              </div>
            </li>
            {/* Footer Menu */}
            <li
              className="menuline"
              style={{
                display: [
                  "superadmin",
                  "branch manager",
                  "telecalling",
                  "data entry",
                  "survey",
                ].includes(userRole)
                  ? "block"
                  : "none",
              }}
            >
              <div className="menu-head" id="sidemenuhead-footermenu">
                <Link
                  to="#"
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu-footermenu"
                  aria-expanded="true"
                  aria-controls="sidemenu-footermenu"
                >
                  <i class="fa-solid fa-film"></i>
                  <span>Footer Menu</span>
                </Link>
              </div>
              <div
                id="sidemenu-footermenu"
                className="collapse"
                aria-labelledby="sidemenuhead-footermenu"
                data-parent="#sidemenu"
              >
                <ul className="Submenu">
                  <li>
                    <NavLink to="/add-footer-menu" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Add
                      Footer Menu
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/manage-footer-menu" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Manage
                      Footer Menu
                    </NavLink>
                  </li>
                </ul>
              </div>
            </li>
            {/* Menu Access */}
            {/* <li className="menuline"
              style={{
                display: ["superadmin"].includes(userRole) ? "block" : "none"
              }}
            >
              <div className="menu-head" id="sidemenuhead-menu-access">
                <Link
                  to="#"
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu-menu-access"
                  aria-expanded="true"
                  aria-controls="sidemenu-menu-access"
                >

                  <i class="fa-solid fa-bars"></i>
                  <span>Menu Access</span>
                </Link>
              </div>
              <div
                id="sidemenu-menu-access"
                className="collapse"
                aria-labelledby="sidemenuhead-menu-access"
                data-parent="#sidemenu"
              >
                <ul className="Submenu">
                  <li>
                    <NavLink to="/add-menu-access" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Add
                      Menu Access
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/manage-menu-access" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Manage
                      Menu Access
                    </NavLink>
                  </li>
                </ul>
              </div>
            </li> */}
            {/* **Menu 4 bHK** */}
            {/* <li className="menuline">
              <div className="menu-head" id="sidemenuhead4">
                <Link
                  to="#"
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu4"
                  aria-expanded="true"
                  aria-controls="sidemenu4"
                >
               
                  <i class="fa-solid fa-building-user"></i>
                  <span>BHK</span>
                </Link>
              </div>
              <div
                id="sidemenu4"
                className="collapse"
                aria-labelledby="sidemenuhead4"
                data-parent="#sidemenu"
              >
                <ul className="Submenu">
                  <li>
                    <NavLink to="/add-bhk" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Add BHK
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/manage-bhk" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Manage
                      BHK
                    </NavLink>
                  </li>
                </ul>
              </div>
            </li> */}
            {/* **Menu 5 Property Type** */}
            {/* <li className="menuline">
              <div className="menu-head" id="sidemenuhead5">
                <Link
                  to="#"
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu5"
                  aria-expanded="true"
                  aria-controls="sidemenu5"
                >
               
                  <i class="fa-solid fa-house"></i>
                  <span>Floor</span>
                </Link>
              </div>
              <div
                id="sidemenu5"
                className="collapse"
                aria-labelledby="sidemenuhead5"
                data-parent="#sidemenu"
              >
                <ul className="Submenu">
                  <li>
                    <NavLink to="/add-floor" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Add Floor
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/manage-floor" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Manage
                      Floor
                    </NavLink>
                  </li>
                </ul>
              </div>
            </li> */}
            {/* Menu * Log Out */}
            {/* <li onClick={handleLogOut} className="menuline">
              <Link>
                <i className="fa-solid fa-right-from-bracket"></i>
                <span>Logout</span>
              </Link>
            </li> */}
          </ul>
        </div>
        <hr className="hr_line" />
        <div
          className="general_div5658 sidebar_menu"
          style={{
            display: "none",
          }}
        >
          <p
            style={{
              color: "#fff",
              fontSize: "15px",
              fontWeight: "600",
              textAlign: "left",
              marginTop: "15px",
              marginLeft: "15px",
            }}
          >
            GENERAL
          </p>
          <ul className="nav Menu_Nav accordion" id="sidemenu">
            {/***Menu 1 Dashboard***/}
            <li className="menuline">
              <NavLink to="/cc" className="" onClick={handlClick}>
                <i class="fa-solid fa-gear"></i>
                <span>Settings</span>
              </NavLink>
            </li>
            <li className="menuline">
              <NavLink to="/cc" className="" onClick={handlClick}>
                <i class="fa-solid fa-shield"></i>
                <span>Security</span>
              </NavLink>
            </li>
          </ul>
        </div>

        <div
          style={{
            paddingBottom: "5px",
          }}
        >
          <hr
            className="hr_line"
            style={{
              marginTop: "0px",
              marginBottom: "10px",
            }}
          />
          <div
            className="Accountdetails"
            style={{
              width: "85%",
              marginInline: "auto",
            }}
          >
            <div
              className="profile_pic"
              style={{
                width: "30px",
                minWidth: "30px",
                height: "30px",
              }}
            >
              <img src={profileP} className="img-fluid" alt="user" />
            </div>
            <div className="namearea">
              <div className="dropdown">
                <Link
                  className="dropdown-toggle"
                  href="#"
                  id="accountDropdown"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <p
                    style={{
                      fontSize: "12px",
                      fontWeight: "600",
                      color: "#fff",
                      marginBottom: "0px",
                    }}
                  >
                    {profileData?.name}
                  </p>
                  <p
                    style={{
                      fontSize: "10px",
                      fontWeight: "600",

                      marginTop: "0px",
                      color: "grey",
                    }}
                  >
                    {profileData?.email}
                  </p>
                </Link>
                <div
                  className="dropdown-menu"
                  aria-labelledby="accountDropdown"
                >
                  {/* <Link className="dropdown-item"><i className="fa-solid fa-user mr-1"></i> Profile</Link> */}

                  <div className="">
                    <button className="dropdown-item" onClick={handleLogOut}>
                      <i className="fa-solid fa-right-from-bracket mr-1"></i>{" "}
                      Log Out
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Sidebar;
